// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2924ccd2]  .v-parallax__image-container{filter:blur(12px);-webkit-filter:blur(12px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
